import React from 'react'

import SignUp from './SignUp'
import SignUpForm from '../SignUpForm'
import Overlay from '../../Overlay'

const Newsletter = ({ content, formData, fetchData, routeProps }) => {
  const overlayId = 'Sign Up Form'
  return (
    <div>
      <SignUp overlayId={overlayId} content={content} routeProps={routeProps} />
      <Overlay id={overlayId} routeProps={routeProps}>
        <SignUpForm
          data={formData}
          fetchData={fetchData}
          routeProps={routeProps}
        />
      </Overlay>
    </div>
  )
}

export default Newsletter



// WEBPACK FOOTER //
// ./src/components/_common/Newsletter/index.js